import React from "react";

import { ReactNode } from "react";
import { Toolbar, Box, styled } from "@mui/material";

import { Header } from "./Header";
import { Main } from "./Main";
import { Footer } from "./Footer";
import { useTranslation } from "react-i18next";

const OuterContainer = styled(Box)`
  display: flex;
  overflow: hidden; /* 外层容器保持hidden */
  height: 100vh;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`;

const InnerContainer = styled(Box)`
  display: flex;
  flex: 1;
  overflow: auto; /* 保持滚动功能 */
  min-height: 0;
  background: transparent;
  margin: 0;
  border-radius: 0; /* 移除圆角 */
  
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`;

interface ILayoutProps {
  children: NonNullable<ReactNode>;
}

export const Layout = ({ children }: ILayoutProps) => {
  const { t } = useTranslation();

  // const getVerifyInfo = () => {
  //   return (
  //     <div>
  //       {t("copyright")}
  //       <div style="width: 300px; margin: 0 auto; padding: 20px 0">
  //         <a
  //           target="_blank"
  //           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010402001486"
  //           style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px"
  //         >
  //           <img src="" style="float: left" />
  //           <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393">川公网安备 51010402001486号</p>
  //         </a>
  //       </div>
  //       <a href="https://beian.miit.gov.cn/" target="_blank">
  //         {t("verifyInfo")}
  //       </a>
  //     </div>
  //   );
  // };

  return (
    <OuterContainer>
      <Header />
      {/* <Toolbar /> */}
      <InnerContainer>
        <Main>{children}</Main>
      </InnerContainer>
      <Footer>
        <Box sx={{ display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            {t("copyright")}
          </Box>
          {" "}
          <Box sx={{ display: "flex", flexWrap: "nowrap", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <a href="https://beian.miit.gov.cn/" target="_blank">
              {t("verifyInfo")}
            </a>
          </Box>
          {" "}
          <Box sx={{ display: "flex", flexWrap: "nowrap", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <img src="/verifyLogo.png" style={{ verticalAlign: "text-bottom", marginRight: "4px" }} />
            {" "}
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010402001486">
              川公网安备 51010402001486号
            </a>
          </Box>
        </Box>
      </Footer>
    </OuterContainer>
  );
};
